import {
  List,
  SimpleForm,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  SelectInput,
  required,
  FormDataConsumer,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  useDataProvider,
  useRefresh,
  SelectArrayInput,
  ArrayField,
  useRecordContext,
  useRedirect,
} from 'react-admin'
import { ExtraPagination, CustomToolbar } from './utils'
import { makeStyles } from '@material-ui/core'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import SplitButton from './common/Buttons/SplitButton'

import { Alert, Typography } from '@mui/material'

const useStyles = makeStyles({
  SelectArrayInput: {
    '&>Label[data-shrink="true"]': {
      '& > span': {
        background: 'white',
        paddingLeft: '5px',
        paddingRight: '5px',
      },
    },
    '&>Label[data-shrink="false"]': {
      position: 'relative',
      top: '16px',
      fontSize: '15px',
    },
  },
})

export const UserEdit = (props) => {
  const classes = useStyles()
  return (
    <Edit {...props}>
      <SimpleForm variant="outlined" toolbar={<CustomToolbar />}>
        <TextField
          source="email"
          label="Name"
          validate={[required()]}
          sx={{ marginBottom: '10px', marginLeft: '3px' }}
        />
        <TextInput
          source="firstname"
          label="Firstname"
          validate={[required()]}
        />
        <TextInput source="lastname" label="Lastname" validate={[required()]} />
        <SelectArrayInput
          className={classes.SelectArrayInput}
          label="Type d'utilisateur"
          source="user_type"
          validate={[required()]}
          choices={[
            { id: 'Admin', name: 'Admin' },
            { id: 'Process Owner', name: 'Process Owner' },
            { id: 'Gestionnaire', name: 'Gestionnaire' },
            { id: 'Comptable', name: 'Comptable' },
            { id: 'Contrat', name: 'Contrat' },
            { id: 'Comptable Universal', name: 'Comptable Universal' },
            { id: 'Hub', name: 'Hub' },
            { id: 'Guest', name: 'Guest' },
          ]}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              !formData.user_type ||
              !formData.user_type.includes('Process Owner')
            ) {
              return null
            }
            return (
              <ReferenceArrayInput
                label="Processes"
                source="processes"
                reference="process"
                perPage={2000}
                sort={{ field: 'name', order: 'ASC' }}
                basePath="/"
              >
                <AutocompleteArrayInput optionText="name" />
              </ReferenceArrayInput>
            )
          }}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              !formData.user_type ||
              !formData.user_type.includes('Gestionnaire')
            ) {
              return null
            }
            return (
              <div>
                <Alert severity="success">
                  <Typography variant="h6">
                    L'attribution du gestionnaire a désormais lieu sur Monday
                    sur le board{' '}
                    <a href="https://hello-syndic.monday.com/boards/207046355/views/42281443">
                      ALL/SUIVI Copros-Infos*
                    </a>{' '}
                    avec l'email manda.fr de l'utilisateur.
                  </Typography>
                </Alert>
                <ReferenceArrayInput
                  label="Copros"
                  source="copros"
                  reference="copros_monday"
                  perPage={2000}
                  sort={{ field: 'code', order: 'ASC' }}
                  basePath="/"
                  disabled
                >
                  <AutocompleteArrayInput optionText="code" disabled />
                </ReferenceArrayInput>
              </div>
            )
          }}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              !formData.user_type ||
              !formData.user_type.includes('Comptable')
            ) {
              return null
            }
            return (
              <div>
                <Alert severity="success">
                  <Typography variant="h6">
                    L'attribution du comptable a désormais lieu sur Monday sur
                    le board{' '}
                    <a href="https://hello-syndic.monday.com/boards/207046355/views/42281443">
                      ALL/SUIVI Copros-Infos*
                    </a>{' '}
                    avec l'email manda.fr de l'utilisateur.
                  </Typography>
                </Alert>
                <ReferenceArrayInput
                  label="Copros"
                  source="copros"
                  reference="copros_monday"
                  perPage={2000}
                  sort={{ field: 'code', order: 'ASC' }}
                  basePath="/"
                  disabled
                >
                  <AutocompleteArrayInput optionText="code" disabled />
                </ReferenceArrayInput>
              </div>
            )
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  )
}

const RolesField = () => {
  const { user_type } = useRecordContext()
  if (!user_type) return null

  return (
    <>
      {user_type.map((item, index) => (
        <Chip label={item} key={index} />
      ))}
    </>
  )
}
const StateAccount = () => {
  const record = useRecordContext()
  const state = record.archived ? 'Désactivé' : 'Active'
  const color = record.archived ? 'error' : 'success'
  return <Chip label={state} color={color} />
}
const ButtonActions = () => {
  const record = useRecordContext()
  const redirect = useRedirect()
  const dataProvider = useDataProvider()
  const refresh = useRefresh()
  const generateActions = async (record) => {
    const handleToggleState = () => {
      dataProvider
        .update('users', {
          id: record.id,
          data: { ...record, archived: !record.archived },
        })
        .then(() => {
          refresh()
        })
        .catch((error) => {
          console.log(error)
          alert(error)
        })
    }
    return [
      {
        option: `${!record.archived ? 'Désactiver ' : 'Activer'}`,
        onClick: () => {
          handleToggleState()
        },
        disabled: false,
      },
      {
        option: 'Editer',
        onClick: () => {
          redirect('edit', 'users', record.id)
        },
        disabled: false,
      },
    ]
  }
  return (
    <SplitButton
      style={{
        float: 'right',
      }}
      getActions={async () => {
        return await generateActions(record)
      }}
    />
  )
}
export const UsersList = (props) => {
  const filters = [
    <Chip
      key={0}
      source="archived"
      label="Utilisateurs archivés"
      defaultValue={true}
    />,
  ]

  return (
    <List
      bulkActionButtons={false}
      exporter={false}
      pagination={<ExtraPagination />}
      filters={filters}
      {...props}
    >
      <Datagrid rowClick={false}>
        <TextField source="email" label="Email" />
        <TextField source="firstname" label="Prénom" />
        <TextField source="lastname" label="Nom de famille" />
        <RolesField />
        <StateAccount label="Statut" />
        <ButtonActions />
      </Datagrid>
    </List>
  )
}

export const UserCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm variant="outlined">
        <TextInput source="email" label="Email" validate={[required()]} />
        <TextInput
          source="firstname"
          label="Firstname"
          validate={[required()]}
        />
        <TextInput source="lastname" label="Lastname" validate={[required()]} />
        <SelectArrayInput
          label="Type d'utilisateur"
          source="user_type"
          validate={[required()]}
          choices={[
            { id: 'Admin', name: 'Admin' },
            { id: 'Process Owner', name: 'Process Owner' },
            { id: 'Gestionnaire', name: 'Gestionnaire' },
            { id: 'Comptable', name: 'Comptable' },
            { id: 'Comptable Universal', name: 'Comptable Universal' },
            { id: 'Contrat', name: 'Contrat' },
            { id: 'Hub', name: 'Hub' },
            { id: 'Guest', name: 'Guest' },
          ]}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              !formData.user_type ||
              !formData.user_type.includes('Process Owner')
            ) {
              return null
            }

            return (
              <ReferenceArrayInput
                label="Processes"
                source="processes"
                reference="process"
                perPage={2000}
                sort={{ field: 'name', order: 'ASC' }}
                basePath="/"
              >
                <AutocompleteArrayInput optionText="name" />
              </ReferenceArrayInput>
            )
          }}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              !formData.user_type ||
              !formData.user_type.includes('Gestionnaire')
            ) {
              return null
            }
            return (
              <div>
                <ReferenceArrayInput
                  label="Copros"
                  source="copros"
                  reference="copros_monday"
                  perPage={2000}
                  sort={{ field: 'code', order: 'ASC' }}
                  basePath="/"
                >
                  <AutocompleteArrayInput
                    optionText="code"
                    shouldRenderSuggestions={(val) => {
                      if (val === undefined) {
                        return false
                      } else {
                        return val.trim().length > 3
                      }
                    }}
                  />
                </ReferenceArrayInput>
              </div>
            )
          }}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (
              !formData.user_type ||
              !formData.user_type.includes('Comptable')
            ) {
              return null
            }
            return (
              <ReferenceArrayInput
                label="Copros"
                source="copros"
                reference="copros_monday"
                perPage={2000}
                sort={{ field: 'code', order: 'ASC' }}
                basePath="/"
              >
                <AutocompleteArrayInput optionText="code" />
              </ReferenceArrayInput>
            )
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  )
}
